__turbopack_context__.v({
  "bar": "nutrition-panel-module___pSKuq__bar",
  "bar_accent": "nutrition-panel-module___pSKuq__bar_accent",
  "bar_neutral": "nutrition-panel-module___pSKuq__bar_neutral",
  "bar_sage": "nutrition-panel-module___pSKuq__bar_sage",
  "bar_warn": "nutrition-panel-module___pSKuq__bar_warn",
  "cal": "nutrition-panel-module___pSKuq__cal",
  "calNa": "nutrition-panel-module___pSKuq__calNa",
  "calNum": "nutrition-panel-module___pSKuq__calNum",
  "calUnit": "nutrition-panel-module___pSKuq__calUnit",
  "dot": "nutrition-panel-module___pSKuq__dot",
  "dot_accent": "nutrition-panel-module___pSKuq__dot_accent",
  "dot_neutral": "nutrition-panel-module___pSKuq__dot_neutral",
  "dot_sage": "nutrition-panel-module___pSKuq__dot_sage",
  "dot_warn": "nutrition-panel-module___pSKuq__dot_warn",
  "estimatedNote": "nutrition-panel-module___pSKuq__estimatedNote",
  "eyebrow": "nutrition-panel-module___pSKuq__eyebrow",
  "gda": "nutrition-panel-module___pSKuq__gda",
  "gdaOf": "nutrition-panel-module___pSKuq__gdaOf",
  "head": "nutrition-panel-module___pSKuq__head",
  "legend": "nutrition-panel-module___pSKuq__legend",
  "legendItem": "nutrition-panel-module___pSKuq__legendItem",
  "mLabel": "nutrition-panel-module___pSKuq__mLabel",
  "mVal": "nutrition-panel-module___pSKuq__mVal",
  "macro": "nutrition-panel-module___pSKuq__macro",
  "macros": "nutrition-panel-module___pSKuq__macros",
  "more": "nutrition-panel-module___pSKuq__more",
  "note": "nutrition-panel-module___pSKuq__note",
  "panel": "nutrition-panel-module___pSKuq__panel",
  "seg": "nutrition-panel-module___pSKuq__seg",
  "seg_accent": "nutrition-panel-module___pSKuq__seg_accent",
  "seg_neutral": "nutrition-panel-module___pSKuq__seg_neutral",
  "seg_sage": "nutrition-panel-module___pSKuq__seg_sage",
  "seg_warn": "nutrition-panel-module___pSKuq__seg_warn",
  "split": "nutrition-panel-module___pSKuq__split",
  "splitBar": "nutrition-panel-module___pSKuq__splitBar",
  "splitLabel": "nutrition-panel-module___pSKuq__splitLabel",
});
